import { Chip } from '@mui/material';
import PropTypes from 'prop-types';

// Failure statuses are intentionally NOT mapped here — they fall back to the
// generic 'Error' chip (see label/color defaults below), matching the original
// list behavior. Only the happy-path statuses plus this feature's own statuses
// (recall / force return) are mapped explicitly.
const STATUS_COLOR = {
  QUEUED: 'default',
  SUBMITTED: 'info',
  ACCEPTED: 'primary',
  SHIPPED: 'secondary',
  DELIVERED: 'success',
  VOIDED: 'default',
  RECALL_REQUESTED: 'warning',
  RECALLED: 'success',
  RECALL_FAILED: 'error',
  ROUTE_TO_DEFAULT: 'success',
};

const STATUS_LABEL = {
  QUEUED: 'Queued',
  SUBMITTED: 'Submitted',
  ACCEPTED: 'Accepted',
  SHIPPED: 'Shipped',
  DELIVERED: 'Delivered',
  VOIDED: 'Voided',
  RECALL_REQUESTED: 'Recall Requested',
  RECALLED: 'Recalled',
  RECALL_FAILED: 'Recall Failed',
  ROUTE_TO_DEFAULT: 'Route to Default',
};

const CentralFillQueueStatusChip = ({ status }) => (
  <Chip
    label={STATUS_LABEL[status] ?? 'Error'}
    color={STATUS_COLOR[status] ?? 'error'}
    size='small'
    sx={{
      fontWeight: 600,
      // The theme maps `warning.main` to the dark perfectRx navy, so a plain
      // color='warning' chip renders dark-on-dark and is unreadable. Paint the
      // recall-requested chip with the theme's real amber + dark text instead.
      ...(status === 'RECALL_REQUESTED' && {
        bgcolor: 'warning.warningColour',
        color: 'text.dark',
      }),
    }}
  />
);

CentralFillQueueStatusChip.propTypes = {
  status: PropTypes.string.isRequired,
};

export default CentralFillQueueStatusChip;
